import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { staticLogoLarge } from '@totem/selectors/preferencesSelectors';

import tjbcSmall from '../../images/johnBuckCompanySmall.png';

import './logos.css';

const HeaderLogoSmall = () => {
  const { userProfile } = useContext(UserProfileContext);
  const navigate = useNavigate();
  const organizationId = userProfile.organization.id;

  let logo = staticLogoLarge;
  switch (organizationId) {
    case '66a294300a1b3e41854b7887': // The John Buck Company
      logo = tjbcSmall;
      break;
    default:
      break;
  }

  return (
    <img
      onClick={() => navigate('/dashboard')}
      style={{ cursor: 'pointer' }}
      alt="Logo"
      src={logo}
      styleName="headerLogoSmall"
    />
  );
};

export default HeaderLogoSmall;
